export const environment = {
  production: false,
  API_URL: 'https://portal-staging.avanacuso.com/api/portal/v1/',
  bucketOrigin: 'https://storage.googleapis.com',
  loanPhotoBucketName: 'es-loan-photo',
  loanDescriptionBucketName: 'es-loan-description',
  participationPhotoBucketName: 'es-participation-photo',
  participationDescriptionBucketName: 'es-participation-description',
  minCalendarDate: new Date(2024, 6, 1)
};